import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/components/Hero.css';
import heroVideo from '../../assets/hero-video.mp4';
import { useToast } from './ToastProvider';

const Hero = () => {
  const toast = useToast();
  return (
    <section className="hero">
      <div className="hero-bg-elements">
        <div className="hero-gradient-1"></div>
        <div className="hero-gradient-2"></div>
        <div className="hero-gradient-3"></div>
      </div>
      
      <div className="container hero-container">
        <div className="hero-content animate-fade-in">
          <div className="hero-badge-container animate-slide-up">

          

            <div className="hero-badge">
              <span className="badge-icon">✨</span>
              <span className="badge-text">AI-Powered Productivity</span>

            </div>

            <div className='company_title_container'>

        
              <span className="badge-text">Pixel Innovators Solutions</span>
                                           
            

          </div>           
          </div>
          
          

          
          <h1 className="hero-title animate-slide-up">
            <span className="text-gradient">Type special tags</span>, get instant AI responses—right inside  input field.
          </h1>
          
          <p className="hero-subtitle animate-slide-up">
            No tab switching. Just type, tag, and watch your prompt become content.
            <span className="hero-highlight">Use your own keywords to activate AI.</span>
          </p>
          
          <div className="hero-cta animate-slide-up">
            <button  onClick={()=>toast.info('Extension Coming Soon!.')} className="btn-primary hero-btn">
             <span onClick={() => window.open("https://chromewebstore.google.com/detail/coagkcndokekpcpmelffnlkmodfnhmjo?utm_source=item-share-cb", "_blank")}>Get Started Free</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </button>
            <Link to="/pricing" className="btn-outline hero-btn-secondary">
              <span>View Pricing</span>
            </Link>
          </div>
          
          <div className="hero-stats animate-slide-up">
            <div className="stat-item">
              <div className="stat-icon">⚡</div>
              <div className="stat-text">Instant AI Answers: GPT Tag selected text to get smart AI responses</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-icon">🔥</div>
              <div className="stat-text">No Copy-Paste Needed: Get help from AI without ever leaving the page</div>
            </div>
          </div>
        </div>
        
        <div className="hero-video-container glass-card">
          <div className="video-overlay">
            <div className="play-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </div>
          </div>
          <video className="hero-video" autoPlay loop muted playsInline>
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};

export default Hero;